var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavIcon7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#141414"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3695_420)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0172 33H29.9835C31.0959 33 32 32.1007 32 30.9959V22.5055C32 21.4 31.0951 20.5014 29.9835 20.5014H28.1849C28.3281 20.4007 28.4455 20.298 28.5266 20.1931C29.2001 19.3278 29.0408 18.0841 28.1702 17.4139C27.8076 17.1354 27.3785 17 26.9523 17C26.3569 17 25.7672 17.2639 25.3745 17.7688C25.174 18.0264 25.037 18.4896 24.9427 19.0132C24.8483 18.4896 24.7114 18.0264 24.5108 17.7688C24.1182 17.2639 23.5291 17 22.9331 17C22.5068 17 22.0778 17.1354 21.7145 17.4146C20.8438 18.084 20.6845 19.3285 21.3581 20.1938C21.4392 20.2987 21.5572 20.4014 21.6998 20.5021H20.0165C18.9041 20.5021 18 21.4014 18 22.5062V30.9959C18 32.1007 18.9049 33 20.0172 33ZM19.1864 30.9959V24.982H24.4068V31.821H20.0173C19.559 31.821 19.1864 31.4508 19.1864 30.9959ZM30.8136 30.9959C30.8136 31.4508 30.4412 31.8216 29.9828 31.8216H25.5933V24.9819H30.8137L30.8136 30.9959ZM26.125 18.3459C26.3241 18.0903 26.626 17.9431 26.9516 17.9431C27.1843 17.9431 27.4044 18.0181 27.5889 18.1605C27.8097 18.3299 27.9501 18.575 27.9858 18.8501C28.0207 19.1251 27.9466 19.3973 27.7761 19.616C27.6028 19.832 26.8286 20.1855 25.8938 20.5015H25.7254C25.796 19.4709 25.951 18.5757 26.125 18.3459ZM22.1093 19.616C21.9388 19.3966 21.8641 19.125 21.899 18.85C21.9339 18.575 22.0751 18.3306 22.2959 18.1605C22.4804 18.0181 22.7012 17.9431 22.9338 17.9431C23.2602 17.9431 23.5613 18.0896 23.7605 18.3452C23.9345 18.5757 24.0896 19.4702 24.1595 20.5007H23.9897C23.0561 20.1855 22.2834 19.8327 22.1093 19.616ZM19.1864 22.5056C19.1864 22.0508 19.5589 21.6799 20.0172 21.6799H29.9835C30.4412 21.6799 30.8143 22.0501 30.8143 22.5056V23.8029H19.1864V22.5056Z",
    fill: "#F2F2F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3695_420"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(17 17)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavIcon7);
export default __webpack_public_path__ + "static/media/nav_icon_7.28e96507f49e377571f35d86054fcd30.svg";
export { ForwardRef as ReactComponent };